<template>
    <v-container fluid>
        <v-layout justify-center >
            <v-flex sm12>
                <v-navigation-drawer
                        persistent
                        :mini-variant="miniVariant"
                        :clipped="true"
                        app
                        fixed
                        v-model="drawer"
                >
                    <v-list>
                        <template v-for="item in items">
                            <v-subheader v-if="item.heading">
                                {{ item.heading }}
                            </v-subheader>
                            <v-list-group
                                    v-else-if="item.children"
                                    :key="item.text"
                            >
                                <v-list-tile slot="activator">
                                    <v-list-tile-action v-if="item.icon">
                                        <v-icon>{{ item.icon }}</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ item.text }}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile
                                        v-for="(child, i) in item.children"
                                        :key="child.text" :to="child.link" router
                                >
                                    <v-list-tile-action>
                                        <v-tooltip bottom>
                                            <v-icon slot="activator">{{ child.icon }}</v-icon>
                                            <span>{{ child.text }}</span>
                                        </v-tooltip>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ '&nbsp;&nbsp;' + child.text }}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list-group>
                            <v-list-tile v-else :key="item.text" :to="item.link" router>
                                <v-list-tile-action>
                                    <v-tooltip bottom>
                                        <v-icon slot="activator">{{ item.icon }}</v-icon>
                                        <span>{{ item.text }}</span>
                                    </v-tooltip>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ item.text }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-navigation-drawer>
                <v-toolbar color="primary" class="darken-1 white--text" dark
                           app
                           fixed
                           clipped-left
                >
                    <v-toolbar-side-icon @click.stop="toggleMenu"></v-toolbar-side-icon>
                    <img src="@/assets/logo.png" alt="Campi Asesores" style="max-height: 60px">
                    <v-toolbar-title><span class="ml-2" style="font-family: 'Crimson Text';font-weight: 600">ASESORES EN SEGUROS</span></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="handleFullScreen">
                        <v-icon>fullscreen</v-icon>
                    </v-btn>
                    <!--
                    <v-menu offset-y origin="center center" :nudge-bottom="14" transition="scale-transition">
                        <v-btn slot="activator" icon flat  @click="notifications=[]">
                            <v-badge color="red" overlap :value="hasNotifications">
                                <span slot="badge">{{ notifications.length}}</span>
                                <v-icon medium >notifications</v-icon>
                            </v-badge>
                        </v-btn>
                        <app-notification-list/>
                    </v-menu>-->
                    <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
                        <v-btn slot="activator" icon large flat>
                            <v-avatar size="30px">
                                <v-icon dark>account_box</v-icon>
                            </v-avatar>
                        </v-btn>
                        <v-list class="pa-0">
                            <v-list-tile v-for="(item,index) in profileItems" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" rel="noopener" :key="index" router>
                                <v-list-tile-action v-if="item.icon">
                                    <v-icon>{{ item.icon }}</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="$store.getters['user/inSudo']" :to="null" @click="$store.dispatch('user/switchBack')" ripple="ripple" rel="noopener" key="inSudo">
                                <v-list-tile-action>
                                    <v-icon>exit_to_app</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>Volver a Usuario</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-content>
                    <router-view/>
                </v-content>
                <app-footer/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import AppNotificationList from '@/components/widgets/list/NotificationList'
  import AppFooter from '@/components/Common/Footer'
  import Util from '../../util'

  export default {
    data () {
      return {
        drawer: !this.$vuetify.breakpoint.smAndDown,
        notifications: [1, 2, 2],
        userDialog: true,
        profileItems: [
          {
            icon: 'account_circle',
            name: 'profile',
            title: 'Mi Perfil',
            click: () => {
            }
          },
          {
            icon: 'exit_to_app',
            href: '#',
            title: 'Salir',
            click: () => {
              this.$store.dispatch('user/logout').then(
                () => this.$router.replace('/')
              )
            }
          }
        ],
        miniVariant: false,
        title: 'Campi Asesores en seguros'
      }
    },
    computed: {
      items () {
        return this.$store.getters['user/menus']
      },
      hasNotifications () {
        return this.notifications.length > 0
      }
    },
    methods: {
      toggleMenu () {
        if (this.drawer === false) {
          this.drawer = true
          this.miniVariant = false
          return
        }
        this.miniVariant = !this.miniVariant
      },
      handleFullScreen () {
        Util.toggleFullScreen()
      }
    },
    name: 'App',
    components: {
      AppFooter,
      AppNotificationList
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Layout/DashboardLayout.vue